import React from 'react'
import { useContext } from 'react';
import { useEffect } from 'react';
import { useState } from 'react';
import SearchBox from '../../customer/components/SearchBox';
import Scroll from '../../shared/components/navigation/Scroll';
import Table from '../../shared/components/Table/Table';
import ErrorModal from '../../shared/components/UIElements/ErrorModal';
import FloatingButton from '../../shared/components/UIElements/FloatingButton';
import LoadingSpinner from '../../shared/components/UIElements/LoadingSpinner';
import { AuthContext } from '../../shared/context/auth-context';
import { useHttpClient } from '../../shared/hooks/http-hook';
import { SendBackTableHeaders , SendBackMobileTableHeaders} from '../../consignment/components/ConsignmentTableHeaders';
import {formatDate} from '../../print/page/Print'
import { useWindow } from '../../shared/hooks/window-hook';
 
const SendBacks = () => {
  const auth = useContext(AuthContext);
  const [sendbacks, setSendbacks] = useState([]);
  const [searchfield, setSearchfield] =useState("")
  const { isLoading, error, sendRequest, clearError } = useHttpClient();
  const { width } = useWindow();
  
  useEffect(() => {
    const fetchSendbacks = async () => {
      let responseData;
      try {
        responseData = await sendRequest(
          process.env.REACT_APP_BACKEND_URL+ "/sendBacks", 
          "GET" , 
          null,
          {Authorization: 'Bearer '+ auth.token}
        );
        setSendbacks(responseData.sendBacks);
      } catch (err) { }
    };
    fetchSendbacks();
  }, [sendRequest, auth.token]);


const filteredSendbacks = sendbacks
  .map(any => {
  return({
    ...any,
    style: any.style.split('_')[0],
    issueDate: any.issueDate ? formatDate(any.issueDate.split('T')[0]) : ""
  })
  })
  .filter((sendback) => {
  return(
    sendback.style.toLowerCase().includes(searchfield.toLowerCase()) ||
    sendback.company.toLowerCase().includes(searchfield.toLowerCase()) ||
    sendback.color.toLowerCase().includes(searchfield.toLowerCase()) ||
    sendback.USSize.toLowerCase().includes(searchfield.toLowerCase()) ||
    sendback.EURSize.toLowerCase().includes(searchfield.toLowerCase()) ||
    String(sendback.quantity).includes(searchfield) ||
    String(sendback.cost).includes(searchfield)||
    String(sendback.price).includes(searchfield) ||
    sendback.issueDate.toLowerCase().includes(searchfield.toLowerCase()) 
    );
  })
  .reverse();

  
  const onSearchChange =(event)=>{
    setSearchfield(event.target.value);
  };
  
  return (
    <React.Fragment>
      <div className="tc">
      <h2>SEND BACKS</h2>
      </div>
      <ErrorModal error={error} onClear={clearError} />
      {isLoading && (
        <div className="center">
          <LoadingSpinner />
        </div>
      )}
      <div className="tc">
        <div style={{ display: "inline-block" }}>
          <SearchBox searchChange={onSearchChange} />
        </div>
      </div>
      <Scroll>
        {!isLoading && filteredSendbacks && (
          <Table
            headers={width > 800 ? SendBackTableHeaders: SendBackMobileTableHeaders}
            content={filteredSendbacks}
          />
        )}
      </Scroll>
      <FloatingButton icon={"back"} />
      </React.Fragment>
  )
}

export default SendBacks;